import React from "react";
import { Box, Typography, Paper, useTheme, alpha } from "@mui/material";
import { Explore as ExploreIcon } from "@mui/icons-material";

export const EmptyState: React.FC = () => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        p: 6,
        textAlign: "center",
        bgcolor: alpha(theme.palette.primary.main, 0.02),
        borderRadius: 3,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: 3,
        }}
      >
        <ExploreIcon sx={{ fontSize: 40, color: "primary.main" }} />
      </Box>
      <Typography variant="h6" color="text.primary" gutterBottom>
        No Public Circles Available
      </Typography>
      <Typography variant="body2" color="text.secondary">
        There are no public circles to join at the moment.
        <br />
        Check back later or create your own circle!
      </Typography>
    </Paper>
  );
};
